import { Injectable } from '@angular/core';
import { SocialSharing } from '@ionic-native/social-sharing/ngx';
import { ToastController } from '@ionic/angular';

import { ApiService } from '../api/api.service';

@Injectable({
  providedIn: 'root'
})
export class SharingService {

  constructor(private socialSharing: SocialSharing, public toastController: ToastController,
              public api: ApiService) { }

  sendSMS(message, phone, useSMSGateway, payload) {
      // When using a 3rd Party SMS Gateway
      if (useSMSGateway) {
          this.api.postApiEndpoint('SendToken', payload).subscribe((resp) => {
              console.log(resp);
              if (resp.ok) {
                // this.info = resp.data;
                this.presentToast(resp.msg, 'success');
              } else {
                // this.info = resp.msg;
                this.presentToast(resp.msg, 'danger');
              }
            }, err => {
                this.presentToast(err.toString(), 'danger');
            });
      } else {
          this.socialSharing.shareViaSMS(message, phone)
              .then((val) => {
                  // this.presentToast('SMS sent !! \n' + val, 'success');
              })
              .catch((err) => {
                  this.presentToast(err.toString(), 'danger');
              });
      }
  }

  sendWhatsapp(message, phone) {
    this.socialSharing.canShareVia('whatsapp', message)
        .then((val) => {
              // this.presentToast('Whatsapp possible !! \n' + val , 'success');
              this.socialSharing.shareViaWhatsAppToReceiver(phone, message)
                .then((res) => {
                    // this.presentToast('Whatsapp sent !! \n' + res , 'success');
                })
                .catch((err) => {
                    this.presentToast(err.toString(), 'danger');
                });
        })
        .catch((err) => {
          this.presentToast(err.toString(), 'danger');
        });
  }

  sendTelegram(message, phone) {
    this.socialSharing.canShareVia('telegram', message)
        .then((val) => {
              this.socialSharing.shareVia('telegram', message)
                .then((res) => {
                    // this.presentToast('Whatsapp sent !! \n' + res , 'success');
                })
                .catch((err) => {
                    this.presentToast(err.toString(), 'danger');
                });
        })
        .catch((err) => {
          this.presentToast(err.toString(), 'danger');
        });
  }

  sendEmail(endpoint,payload) {
      this.api.postApiEndpoint(endpoint, payload).subscribe((resp) => {
        console.log(resp);
        if (resp.ok) {
          // this.info = resp.data;
          this.presentToast('Email sent successfully !! \n' + resp.msg , 'success');
        } else {
          // this.info = resp.msg;
          this.presentToast(resp.msg, 'danger');
        }
      }, err => {
          this.presentToast(err.toString(), 'danger');
      });
    
      /*this.socialSharing.canShareViaEmail()
          .then((val) => {
              // this.presentToast('Email possible !! \n' + val , 'success');
              this.socialSharing.shareViaEmail(message, 'Utility Token', [email])
                  .then((res) => {
                      // this.presentToast('Email sent successfully !! \n' + res , 'success');
                  })
                  .catch((err) => {
                      this.presentToast(err.toString(), 'danger');
                  });
          })
          .catch((err) => {
              this.presentToast(err.toString(), 'danger');
          });*/
  }

  sendOther(message) {
      this.socialSharing.share(message)
          .then((res) => {
              // this.presentToast('Shared successfully !! \n' , 'success');
          })
          .catch((err) => {
              this.presentToast(err.toString(), 'danger');
          });
  }

  testSendVia(app, msg) {
    this.socialSharing.canShareVia(app, msg)
        .then((val) => {
          this.presentToast('Whatsapp possible !! \n' + val , 'success');
        })
        .catch((err) => {
          this.presentToast(err.toString(), 'danger');
        });
  }

  async presentToast(msg, color) {
    const toast = await this.toastController.create({
      message: msg,
      duration: 3000,
      position: 'bottom',
      color
    });
    toast.present();
  }
}
